import ControllerBase from '../../../../global/js/ControllerBase';
import {getCookie, setCookie} from "../../../../global/js/Utils";

export default class ControllerRedirectModal extends ControllerBase {
  private asked;
  private close;
  private noRedirect;
  private pageId;
  private pageUrl;
  private redirect;
  private redirected;

  constructor(element: HTMLElement) {
    super(element);
    this.init();
  }

  private closeModal(action = 0) {
    document.body.style.overflow = 'auto';
    this.$element.remove();
    if (action == 2) {
      setCookie(`redirected-${this.pageId}`, 600, 'true');
      setCookie(`redirect-${this.pageId}`, 3600 * 24 * 7, 'true');
      document.location.href = this.pageUrl;
    } else if (action == 1)
      setCookie(`redirect-${this.pageId}`, 3600 * 24 * 7, 'false');
  }

  private openModal() {
    document.body.style.overflow = 'hidden';
    this.$element.classList.remove('d-none');
  }

  private init() {
    this.pageId = this.$element.getAttribute('data-page-id') || '';
    this.pageUrl = this.$element.getAttribute('data-page-url') || '';
    this.close = this.$element.querySelector('.m-redirect-modal-close') as HTMLButtonElement;
    this.close?.addEventListener('click', () => this.closeModal(0));
    this.redirect = this.$element.querySelector('[data-action="redirect"]') as HTMLButtonElement;
    this.redirect?.addEventListener('click', () => this.closeModal(2));
    this.noRedirect = this.$element.querySelector('[data-action="no-redirect"]') as HTMLButtonElement;
    this.noRedirect?.addEventListener('click', () => this.closeModal(1));
    this.asked = getCookie(`redirect-${this.pageId}`);
    if (this.asked) {
      if (this.asked === 'true') {
        this.redirected = getCookie(`redirected-${this.pageId}`);
        if (!this.redirected) {
          setCookie(`redirected-${this.pageId}`, 600, 'true');
          document.location.href = this.pageUrl;
        }
      }
    } else this.openModal();
  }
}